var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlignRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 12C10.7761 12 11 11.7761 11 11.5L11 0.5C11 0.223858 10.7761 -3.39262e-08 10.5 -2.18557e-08C10.2239 -9.78512e-09 10 0.223858 10 0.5L10 11.5C10 11.7761 10.2239 12 10.5 12Z",
    fill: "#232629"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    rx: 1,
    transform: "matrix(-1 0 0 1 9 2)",
    fill: "#232629"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    rx: 1,
    transform: "matrix(-1 0 0 1 9 7)",
    fill: "#232629"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/AlignRight.79f5d12839aa7c18d06eee5e80b908b7.svg";
export { ForwardRef as ReactComponent };